import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bed"} maskId="square-filled-radius-0-stroke-1-IconBed"><path d="M4 4H11.5V10H4V4Z" fill="currentColor"/><path d="M12.5 10V4H20V10H12.5Z" fill="currentColor"/><path d="M22 11H2V18H4V20H5V18H19V20H20V18H22V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBed;
